import { 
	AuthRepository,
	MensurationsRepository,
	MenagementsRepository,
	ComunicationsRepository,
	UserRepository
} from "../../api";


export class SignupController {
	constructor(context) {
		this.authRepo = new AuthRepository();
		this.mensurationsRepo = new MensurationsRepository();
		this.menagementsRepo = new MenagementsRepository();
		this.comunicationsRepo = new ComunicationsRepository();
		this.userRepo = new UserRepository();

		this.createUser = this.createUser.bind(context);
	}

	async createUser(e) {
		e.preventDefault();

		const validate = this.controller.validate(this.state.values);
		if(!validate.validated){
			Materialize.toast(`Campos ${validate.keys} invalidos`, 4000);
			const state = this.getState();
			state.errors = validate.errors;
			return this.callback(state);
		}
		
		const toApi = this.controller.mapToApi(this.state.values.values);

		const userPromise = await this.controller.authRepo.create(toApi);

		if(!userPromise.error){
			const mensurationsPromise 	= await this.controller.mensurationsRepo.create(userPromise.data.user_id, {});
			const menagementsPromise 		= await this.controller.menagementsRepo.create(userPromise.data.user_id, {});
			const comunicationsPromise 	= await this.controller.comunicationsRepo.create(userPromise.data.user_id, {});
			
			const authPromise 					= await this.controller.authRepo.authorize(toApi.email, toApi.password);

			if(!authPromise.error){
				Materialize.toast('Usuário cadastrado com sucesso', 4000);
				window.sessionStorage.setItem("session_token", authPromise.data.token);
				return this.props.router.push("/dashboard");
			}
		} else if(userPromise.error.code == "602"){
			return Materialize.toast('Email já cadastrado', 4000);
		} else if(userPromise.error.code == "624"){
			return Materialize.toast('CNPJ já cadastrado', 4000);
		} else if (userPromise.error) {
			return Materialize.toast(`ERRO [${userPromise.error.code}]`, 4000);
		}
		return this.props.router.push("/");
	}

	validarCNPJ(cnpj){

		if(!cnpj)
			return false;
 
		cnpj = cnpj.replace(/[^\d]+/g,'');
	 
		if(cnpj == '') return false;
		 
		if (cnpj.length != 14)
			return false;
	 
		// Elimina CNPJs invalidos conhecidos
		if (cnpj == "00000000000000" || 
			cnpj == "11111111111111" || 
			cnpj == "22222222222222" || 
			cnpj == "33333333333333" || 
			cnpj == "44444444444444" || 
			cnpj == "55555555555555" || 
			cnpj == "66666666666666" || 
			cnpj == "77777777777777" || 
			cnpj == "88888888888888" || 
			cnpj == "99999999999999")
			return false;
			 
		// Valida DVs
		let tamanho = cnpj.length - 2;
		let numeros = cnpj.substring(0,tamanho);
		let digitos = cnpj.substring(tamanho);
		let soma = 0;
		let pos = tamanho - 7;
		for (let i = tamanho; i >= 1; i--) {
		  soma += numeros.charAt(tamanho - i) * pos--;
		  if (pos < 2)
				pos = 9;
		}
		let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
		if (resultado != digitos.charAt(0))
			return false;
			 
		tamanho = tamanho + 1;
		numeros = cnpj.substring(0,tamanho);
		soma = 0;
		pos = tamanho - 7;
		for (let i = tamanho; i >= 1; i--) {
		  soma += numeros.charAt(tamanho - i) * pos--;
		  if (pos < 2)
				pos = 9;
		}
		resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
		if (resultado != digitos.charAt(1))
			  return false;
			   
		return true;
		
	}

	validate(values) {

		const errors = {};
		let validated = true;
		let keys = "";

		if(!values.nameCompany) {
			errors.nameCompany = "Campo obrigatório.";
			validated = false;
			keys += keys ? " e nome da empresa" : "nome da empresa";
		}

		if(!this.validarCNPJ(values.cnpj)){
			errors.cnpj = "Campo obrigatório e deve ser um documento válido.";
			validated = false;
			keys += keys ? " e CNPJ da empresa" : "CNPJ da empresa";
		}

		if(!values.nameCompany) {
			errors.nameCompany = "Campo obrigatório.";
			validated = false;
			keys += keys ? " e nome da empresa" : "nome da empresa";
		}

		if(!values.nameUser) {
			errors.nameUser = "Campo obrigatório.";
			validated = false;
			keys += keys ? " e nome do responsável" : "nome do responsável";
		}

		if(!values.role) {
			errors.role = "Campo obrigatório.";
			validated = false;
			keys += keys ? " e cargo" : "cargo";
		}

		if (!values.email || values.email.toString().indexOf("@") < 0 || values.email.toString().indexOf(".") < 0){
			errors.email = "Email invalido.";
			validated = false;
			keys += keys ? " e email" : "email";
		}

		if(values.password != values.confirmPassword){
			errors.password = "Senha e confirmar senha não são iguais.";
			validated = false;
			keys += keys ? " e senha" : "senha";
		}else if(values.password.length < 6){
			errors.password = "Senha minima 6 caracteres.";
			validated = false;
			keys += keys ? " e senha" : "senha";
		}

		return {errors, validated, keys};

	}

	mapToApi(values) {

		return {
			quant_staff		: parseInt(values.quantStaff),
			name_user		: values.nameUser,
			name_company	: values.nameCompany,
			role			: values.role,
			email			: values.email.toLowerCase(),
			password		: values.password,
			cnpj			: values.cnpj.replace(/[^\d]+/g,''),
			site			: values.site,
			address			: { ...values.address.address },
			atividade		: values.atividade,
		};
	}
}



// WEBPACK FOOTER //
// src/controllers/lib/SignupController.js